import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import billing from './modules/billing'
import codes from './modules/codes'
import campaigns from './modules/campaigns'
import dashboard from './modules/dashboard'
import elabel from './modules/elabel'
import landingPages from './modules/landing-pages'
import products from './modules/products'
import qr from './modules/qr'
import redirection from './modules/redirection'
import snackbar from './modules/snackbar'
import prefixes from './modules/prefixes'
import members from './modules/members'
import upgrade from './modules/upgrade'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    billing,
    codes,
    dashboard,
    elabel,
    campaigns,
    landingPages,
    products,
    qr,
    redirection,
    snackbar,
    prefixes,
    members,
    upgrade
  }
})
